"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asciiPattern = exports.asciiExtendedPattern = void 0;
exports.default = getRegExp;
exports.uppercaseLettersNumbersPattern = exports.strictEmailRegex = exports.phoneNumberUkRegex = exports.phoneNumberUkMobileRegex = exports.phoneNumberRegex = exports.passwordRegexLong = exports.passwordRegex = exports.numbersSpacesPattern = exports.numbersSpacesDashesBracketsPlusPattern = exports.numbersSpacesDashesBracketsPattern = exports.numbersSlashPattern = exports.numbersPositiveRegex = exports.numbersPattern = exports.mustContainAlphaNumericsRegex = exports.lettersSingleDashApostropheSpaceRegex = exports.lettersPattern = exports.lettersNumbersSpacesPattern = exports.lettersNumbersSpacesDashPattern = exports.lettersNumbersPattern = exports.lettersNumbersDotDashApostropheSpacePattern = exports.lettersDotPattern = exports.lettersDotDashApostropheSpacePattern = exports.lettersDashApostropheSpacePattern = exports.expiryDateRegex = exports.emailRegex = exports.emailInvalidExtensionRegex = exports.emailInvalidCharsRegex = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _passwordConstants = _interopRequireDefault(require("../constants/passwordConstants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// email regex from ATG
/**
 * @deprecated This will be removed in version 27.
 */
var emailRegex = exports.emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

/**
 * @deprecated This will be removed in version 27.
 */
var strictEmailRegex = exports.strictEmailRegex = /(?!.*\.{2})^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z]{2,}))$/i;

/**
 * @deprecated This will be removed in version 27.
 */
var emailInvalidCharsRegex = exports.emailInvalidCharsRegex = /["(),:;<>[\\\]\s]/g;

/**
 * @deprecated This will be removed in version 27.
 */
var emailInvalidExtensionRegex = exports.emailInvalidExtensionRegex = /[-!#$%&'*+/=?^_0-9]|^[a-z]{1}$/i;

/**
 * @deprecated This will be removed in version 27.
 */
var passwordRegex = exports.passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W_]{8,20}$/;

/**
 * @deprecated This will be removed in version 27.
 */
var passwordRegexLong = exports.passwordRegexLong = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d\\W_]{8,".concat(_passwordConstants.default, "}$"));

/**
 * @deprecated This will be removed in version 27.
 */
var phoneNumberRegex = exports.phoneNumberRegex = /^0([1238]{1}[0-9]{7,9})$|^0(7[0-9]{9})$/;

/**
 * @deprecated This will be removed in version 27.
 */
var phoneNumberUkRegex = exports.phoneNumberUkRegex = /^((\+44(\s)?)|0)[12387]{1}\d{3}(\s)?\d{6}$/;

/**
 * @deprecated This will be removed in version 27.
 */
var phoneNumberUkMobileRegex = exports.phoneNumberUkMobileRegex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;

/**
 * @deprecated This will be removed in version 27.
 */
var expiryDateRegex = exports.expiryDateRegex = /^\d{2}\/\d{2}$/;

/**
 * @deprecated This will be removed in version 27.
 */
var numbersPositiveRegex = exports.numbersPositiveRegex = /^([1-9]+\d*)+$/;

/**
 * @deprecated This will be removed in version 27.
 */
var asciiPattern = exports.asciiPattern = '\\x00-\\x7F';

/**
 * @deprecated This will be removed in version 27.
 */
var asciiExtendedPattern = exports.asciiExtendedPattern = '\\x00-\\xFF';

/**
 * @deprecated This will be removed in version 27.
 */
var numbersPattern = exports.numbersPattern = '0-9';

/**
 * @deprecated This will be removed in version 27.
 */
var numbersSlashPattern = exports.numbersSlashPattern = '0-9\\/';

/**
 * @deprecated This will be removed in version 27.
 */
var numbersSpacesPattern = exports.numbersSpacesPattern = '0-9\\s';

/**
 * @deprecated This will be removed in version 27.
 */
var numbersSpacesDashesBracketsPattern = exports.numbersSpacesDashesBracketsPattern = '0-9\\s\\-\\(\\)';

/**
 * @deprecated This will be removed in version 27.
 */
var numbersSpacesDashesBracketsPlusPattern = exports.numbersSpacesDashesBracketsPlusPattern = '0-9\\s\\-\\(\\)\\+';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersPattern = exports.lettersPattern = 'A-Za-z';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersNumbersPattern = exports.lettersNumbersPattern = 'A-Za-z0-9';

/**
 * @deprecated This will be removed in version 27.
 */
var uppercaseLettersNumbersPattern = exports.uppercaseLettersNumbersPattern = 'A-Z0-9';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersNumbersSpacesPattern = exports.lettersNumbersSpacesPattern = 'A-Za-z0-9\\s';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersNumbersSpacesDashPattern = exports.lettersNumbersSpacesDashPattern = 'A-Za-z0-9\\s\\-';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersDotPattern = exports.lettersDotPattern = 'A-Za-z.';

/**
 * @deprecated This will be removed in version 27.
 */
var lettersDotDashApostropheSpacePattern = exports.lettersDotDashApostropheSpacePattern = "A-Za-z.\\-'\\s";

/**
 * @deprecated This will be removed in version 27.
 */
var lettersDashApostropheSpacePattern = exports.lettersDashApostropheSpacePattern = "\\xC0-\\xFFA-Za-z\\-'\\s";

/**
 * @deprecated This will be removed in version 27.
 */
var mustContainAlphaNumericsRegex = exports.mustContainAlphaNumericsRegex = /[A-Za-z0-9]/;

/**
 * @deprecated This will be removed in version 27.
 */
var lettersSingleDashApostropheSpaceRegex = exports.lettersSingleDashApostropheSpaceRegex = /(\xC0-\xFFA-Za-z\-'\s)|^(?!.*[0-9])((?!.*\s{2,})(?!.*\-{2,})(?!.*\'{2,}))/g;

/**
 * @deprecated This will be removed in version 27.
 */
var lettersNumbersDotDashApostropheSpacePattern = exports.lettersNumbersDotDashApostropheSpacePattern = "A-Za-z0-9.\\-'\\s";

/**
 * @deprecated This will be removed in version 27.
 */
function getRegExp(pattern) {
  if (!(0, _isString.default)(pattern)) {
    return undefined;
  }
  return new RegExp("^[".concat(pattern, "]+$"));
}